import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableInformeGerencialView.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        // Extending the summTreeColumn filter to calculate and display summary values
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summary display for the tree column.
                 * @param {Object} master - The master view.
                 * @param {Object} node - The node to refresh.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.numberFormat(result);
                    } else {
                        if (value.columnId === 'GgrPorc') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the existing summColumn filter
        );

        // Returning the layout configuration for the view
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Defining a treetable view
                            id: 'treetable', // ID for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            scheme: {
                                $group: {
                                    /**
                                     * Grouping function for the treetable.
                                     * @param {Object} obj - The data object to group.
                                     * @returns {string} The HTML string for the group header.
                                     */
                                    by: function (obj) {
                                        return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Pais; // Grouping by country with an icon
                                    },
                                    css: 'bold', // CSS class for the group header
                                    map: {
                                        CantidadTickets: ['CantidadTickets', 'sum'], // Mapping fields for summation
                                        CantidadTicketsCasino: ['CantidadTicketsCasino', 'sum'],
                                        CantidadTicketsCasinoVivo: ['CantidadTicketsCasinoVivo', 'sum'],
                                        TotalTickets: ['TotalTickets', 'sum'],
                                        AmountDeposits: ['AmountDeposits', 'sum'],
                                        AmountWinnings: ['AmountWinnings', 'sum'],
                                        Deposits: ['Deposits', 'sum'],
                                        WithdrawPending: ['WithdrawPending', 'sum'],
                                        Paid: ['Paid', 'sum'],
                                        Stake: ['Stake', 'sum'],
                                        StakeCasino: ['StakeCasino', 'sum'],
                                        StakeLiveCasino: ['StakeLiveCasino', 'sum'],
                                        TotalStake: ['TotalStake', 'sum'],
                                        Payout: ['Payout', 'sum'],
                                        PayoutCasino: ['PayoutCasino', 'sum'],
                                        PayoutLiveCasino: ['PayoutLiveCasino', 'sum'],
                                        TotalPayout: ['TotalPayout', 'sum'],
                                    },
                                },
                            },
                            bready: function () {
                                this.openAll(); // Expanding all rows on ready
                            },
                            scroll: 'xy', // Enabling both horizontal and vertical scrolling
                            columns: [
                                {
                                    id: 'Fecha', // Column ID for date
                                    header: _('Fecha'), // Localized header for date
                                    width: 170, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Displaying group header
                                        return obj.Fecha; // Returning date value
                                    },
                                },
                                {
                                    id: 'Moneda', // Column ID for currency
                                    header: _('Moneda'), // Localized header for currency
                                    width: 70, // Column width
                                },
                                {
                                    id: 'CantidadTickets', // Column ID for ticket count
                                    header: _('Cantidad Tickets'), // Localized header for ticket count
                                    format: webix.i18n.intFormat, // Formatting function for integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'CantidadTicketsCasino', // Column ID for casino ticket count
                                    header: _('Cant Tickets Casino'), // Localized header for casino ticket count
                                    format: webix.i18n.intFormat, // Formatting function for integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'CantidadTicketsCasinoVivo', // Column ID for live casino ticket count
                                    header: _('Cant Tickets Casino Vivo'), // Localized header for live casino ticket count
                                    format: webix.i18n.intFormat, // Formatting function for integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'TotalTickets', // Column ID for total tickets
                                    header: _('Total Tickets'), // Localized header for total tickets
                                    format: webix.i18n.intFormat, // Formatting function for integer
                                    width: 120, // Column width
                                },
                                {
                                    id: 'AmountDeposits', // Column ID for deposit amount
                                    header: _('Saldo Recargas'), // Localized header for deposit amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'AmountWinnings', // Column ID for winnings amount
                                    header: _('Saldo Disp Retiro'), // Localized header for winnings amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Deposits', // Column ID for deposits
                                    header: _('Valor Recargas'), // Localized header for deposits
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'WithdrawPending', // Column ID for pending withdrawals
                                    header: _('Nota de retiro pendiente'), // Localized header for pending withdrawals
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Paid', // Column ID for paid amount
                                    header: _('Valor Pagado'), // Localized header for paid amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Stake', // Column ID for stake amount
                                    header: _('Valor Apostado'), // Localized header for stake amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'StakeCasino', // Column ID for casino stake amount
                                    header: _('Vlr Ap. Casino'), // Localized header for casino stake amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 150, // Column width
                                },
                                {
                                    id: 'StakeLiveCasino', // Column ID for live casino stake amount
                                    header: _('Vlr Ap. Casino Vivo'), // Localized header for live casino stake amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 170, // Column width
                                },
                                {
                                    id: 'TotalStake', // Column ID for total stake
                                    header: _('Total Apostado'), // Localized header for total stake
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'Payout', // Column ID for payout amount
                                    header: _('Valor premios'), // Localized header for payout amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'PayoutCasino', // Column ID for casino payout amount
                                    header: _('Vlr Pr. Casino'), // Localized header for casino payout amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'PayoutLiveCasino', // Column ID for live casino payout amount
                                    header: _('Vlr Pr. Casino Vivo'), // Localized header for live casino payout amount
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                                {
                                    id: 'TotalPayout', // Column ID for total payout
                                    header: _('Total premios'), // Localized header for total payout
                                    format: webix.i18n.numberFormat, // Formatting function for number
                                    width: 130, // Column width
                                },
                            ],
                            /**
                             * Executes when the grid is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extending with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Displaying no data message
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disabling auto width
                            math: true, // Enabling mathematical operations
                            datafetch: 10, // Number of data items to fetch
                            pager: 'pagerA', // ID for the pager component
                            leftSplit: screen.width < 500 ? 0 : 2, // Adjusting left split based on screen width
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        grid = $$('treetable'); // Getting the treetable instance
        var url = devConfig.geturlApi() + 'es/Financial/GetUsuarioOnlineResumido'; // API URL for fetching data

        // Event listener for filtering data based on user input
        this.on(this.app, 'usuarioOnlineResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Converting filter data to entries
            var string1 = ''; // Query string for API request
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Splitting date range
                        console.log(date); // Logging date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Adding dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Adding dateTo to query string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Adding other filter parameters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Formatting date
                                string1 = string1 + '&dateFrom=' + date; // Adding dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Adding dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Converting nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Creating date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Adding dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Creating date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Adding dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clearing existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Loading new data into the grid
            $$('filterPopup').hide(); // Hiding the filter popup
        });

        // Event listener for item click to trigger user selection
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Getting the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Triggering user selection event
        });

        // Event listener for player selection to load data based on selected player
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Loading data for the selected player
            );
        });
    }
}

// FILE DOCUMENTED
